import { newGame, status } from "../game/state";

export function PlayAgain() {
  if (status.value === "playing") return null;
  return (
    <div class="playagain">
      <button type="button" class="playagain__button" onClick={() => newGame()}>
        Play Again
      </button>
    </div>
  );
}
